
import React from 'react';
import ReactDOM from 'react-dom'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect }  from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { languageManager } from '../utils/languageManager'

import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SettingsSharpIcon from '@material-ui/icons/SettingsSharp';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import Tooltip from '@material-ui/core/Tooltip';


import { COLOR } from '../App/constants';



const styles = theme => ({  
    listSlides: {
      borderTop: '1px solid #DDD',
      //borderBottom: '1px solid #DDD',
      marginBottom: -1,     
      display: 'flex',
      alignItems: 'start', 
    },
    itemName: {
      //whiteSpace: 'nowrap',
      //overflow: 'hidden',
      //textOverflow:'ellipsis',
      color: '#777',
      marginTop: 4,
      userSelect: 'none',
      cursor: 'pointer',

    },
    iconHelp: {
      color: '#777',
      margin: '1px 5px',
    },
    iconPlay: {
      marginLeft: 0,
      width: '2em',
      height: '2em',
      color: 'limegreen',
      //color: '#777',      
      //transform: 'translateX(-5px)',
    },
    iconAction: {
      marginLeft: 0,
      width: '1.5em',
      height: '1.5em',
      color: '#777',      
      //transform: 'translateX(-5px)',
    },
    iconDisabled: {
      color: '#DDD',
    },
    iconContainer: {
      display:'flex',
      height: '3.5em',
      alignItems: 'center',
    },
    customTooltipWidth: {
      maxWidth: 500,
      margin: 2,
    },
    panelDetails: {
      alignItems: 'center',                 
      padding: "0px 24px 8px 24px",
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    panelSummary: {
      width: '100%',
      overflowWrap: 'break-word',
      alignItems: 'center',     
    },    
    itemSlide: {
      minHeight: 'auto',
      //height: "2em",    
      height: "100%",  
    },
    slideName: {
      width: '90%',
    },
    actionButton: {
      padding: 0,
      marginRight: (theme.spacing.unit*2),
    },
    actionButtonLabel: {
      flexDirection: 'column',
    },
});

class FwSlideListItem extends React.Component {

  constructor(props) {
    super(props);
    this.myRefExpansion = React.createRef();
  }

  componentDidMount() {  
    var {id} = this.props;  
    
    //Despues de terminar la referencia si es el primero coloca un listener para el tema de 
    //terminar la animación de expansión, esto se usa para el tutorial pues cuando se termine 
    //de expandir debe pasar al paso siguiente
    if(id===0) {
      var expandItem = document.getElementById("expanden_item"+id);                
      console.log('Props',this.props);
      console.log('Pone listener de fin de animación ',expandItem,document.getElementById("item"+id));
    
      var itemDiv = document.getElementById("item"+id);

      if(itemDiv && !this.props.helpItem) {
        document.getElementById("item"+id).addEventListener('transitionend', (event) => { 

            if(event.propertyName==="height") {
              if(this.props.transitionEnd) this.props.transitionEnd(id);
            }
            console.log('LISTENN Esta es la que termina',event);
            //Este evento se llama una vez por cada uno de los elementos que componen un ExpansionPanel
            //pero solo le hacemos caso si se trata del summary         
            /*if(this.isDescendant(event.target,expandItem)) {
              if(this.props.transitionEnd) this.props.transitionEnd(id);
            }*/
        }, false)        
      }

    }     
  }

  handleClickListItem = (evt) => {
    console.log('Click a ' + this.props.slideName)
    //this.props.dispatch(closeModalWindow());  
  }
  
  onMenuItemClick = actionClicked => () => {
    this.props.onSlideItemClick(this.props.id,actionClicked,this.props.cloudObject,this.props.slideName);    
  }

  isDescendant = (parent, child)  => {
      if(parent===null || child===null) return false;
     var node = child.parentNode;
     while (node != null) {
         if (node == parent) {
             return true;
         }
         node = node.parentNode;
     }
     return false;
  }

  render() {
    const { classes,slideName,openedObj,id } = this.props;
       
    //Si no es un item con información de diapositivas sino un item de ayuda
    //esto pasa cuando el usuario no tiene diapositivas entonces se le muestra un
    //item que dice que debe abrir powerpoint
    if(this.props.helpItem) {      
      return (
        <ListItem id={"itemNoSlides"} className={classes.listSlides}>        
          <HelpOutlineIcon className={classes.iconHelp}/>
          <Tooltip title={
            languageManager.getLangWord('TOOLTIP_HELPITEM')
          } classes={{ tooltip: classes.customTooltipWidth }} enterTouchDelay={200}>
            <div className={classes.itemName}>{slideName}</div>
           </Tooltip>  
        </ListItem>      
      );
    }

    var slideIcon = this.props.isCloud?<CloudIcon className={classes.iconHelp}/>:<DesktopWindowsIcon className={classes.iconHelp}/>
    
    return (
      <React.Fragment>
        <ExpansionPanel 
            id={"item"+id} 
            expanded={openedObj('get') === id} 
            onChange={ (evt,expanded) => { 
                if(expanded) {
                  setTimeout(() => {
                    try {
                      ReactDOM.findDOMNode(this).scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                      });
                    }
                    catch(e) {}  
                  }, 500);
                }
                openedObj('set',id) 
              } 
            }            
            >

          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.itemSlide} classes={{ content: classes.panelSummary, expanded: classes.panelSummaryExpanded }}>
            <div className={classes.slideName}>{slideName}</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails 
              id={"expanded_item"+id}
              className={classes.panelDetails}
            >
            <Button id={"play_item"+id} className={classes.actionButton} classes={{ label: classes.actionButtonLabel }} onClick={this.onMenuItemClick("play")}> <div className={classes.iconContainer}><PlayArrowIcon className={classes.iconPlay} /></div> <div>{languageManager.getLangWord('PLAY_OPTION')}</div> </Button>
            {!this.props.isCloud && <Button className={classes.actionButton} classes={{ label: classes.actionButtonLabel }} onClick={this.onMenuItemClick("upload")}> <div className={classes.iconContainer}><CloudUploadIcon className={classes.iconAction} /></div> <div>{languageManager.getLangWord('SAVE_OPTION')}</div> </Button>}
            <Button className={classes.actionButton} classes={{ label: classes.actionButtonLabel }} onClick={this.onMenuItemClick("edit")}> <div className={classes.iconContainer}><EditIcon className={classes.iconAction} /></div> <div>{languageManager.getLangWord('EDIT_OPTION')}</div> </Button>
            <Button className={classes.actionButton} classes={{ label: classes.actionButtonLabel }} onClick={this.onMenuItemClick("conf")}> <div className={classes.iconContainer}><SettingsSharpIcon className={classes.iconAction} /></div> <div>{languageManager.getLangWord('CONF_OPTION')}</div> </Button>
            {this.props.isCloud && <Button className={classes.actionButton} classes={{ label: classes.actionButtonLabel }} onClick={this.onMenuItemClick("delete")}> <div className={classes.iconContainer}><DeleteIcon className={classes.iconAction} /></div> <div>{languageManager.getLangWord('DELETE')}</div> </Button>}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  }
}  
  
FwSlideListItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

FwSlideListItem.contextTypes = {
  store: PropTypes.object,
};

export default connect()(withStyles(styles,{ withTheme: true })(FwSlideListItem));



// WEBPACK FOOTER //
// ./src/containers/components/FwSlideListItem.js